module.exports = __webpack_public_path__ + "static/img/erweima.c32a3a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/erweima.jpg
// module id = rXaU
// module chunks = 1